module.exports = __webpack_public_path__ + "img/down_point_filtered_default.233c029f.svg";